export const VERSION = `/v1`;
export const ROUTE_ACCOUNTS = `${VERSION}/accounts`;

export const ROUTE_ACCOUNTS_CARD = `${ROUTE_ACCOUNTS}/card`;
export const ROUTE_ACCOUNTS_ADDRESS = `${ROUTE_ACCOUNTS}/address`;
export const ROUTE_ACCOUNTS_TRANSACTION = `${ROUTE_ACCOUNTS}/transaction`;

export const ROUTE_ACCOUNTS_CUSTOM = `${ROUTE_ACCOUNTS}/custom`;
export const ROUTE_ACCOUNTS_VENMO = `${ROUTE_ACCOUNTS}/venmo`;
export const ROUTE_ACCOUNTS_PAYPAL = `${ROUTE_ACCOUNTS}/paypal`;
export const ROUTE_ACCOUNTS_WHOLE_FOODS = `${ROUTE_ACCOUNTS}/whole_foods`;
export const ROUTE_ACCOUNTS_AMAZON = `${ROUTE_ACCOUNTS}/amazon`;
export const ROUTE_ACCOUNTS_GAS_STATION = `${ROUTE_ACCOUNTS}/gas_station`;
export const ROUTE_ACCOUNTS_GREEN_DOT = `${ROUTE_ACCOUNTS}/green_dot`;
export const ROUTE_ACCOUNTS_ATM = `${ROUTE_ACCOUNTS}/atm`;
export const ROUTE_ACCOUNTS_UBER = `${ROUTE_ACCOUNTS}/uber`;
export const ROUTE_ACCOUNTS_RESTAURANT = `${ROUTE_ACCOUNTS}/restaurant`;